import React from 'react';

import {
  PlusOneSideSheetHeader,
  PlusOneSideSheetContent,
  PlusOneSideSheetFooter
} from './Sections';

export const PlusOneSideSheet: React.FC = () => {
  return (
    <>
      <PlusOneSideSheetHeader />
      <div className="tw-flex tw-flex-grow tw-flex-col tw-gap-6 tw-overflow-y-auto">
        <PlusOneSideSheetContent />
      </div>
      <PlusOneSideSheetFooter />
    </>
  );
};
